import { type PageType } from '@redteclab/gtm-datalayer-library'

import { PUBLIC_API_PREFIX } from '../../global-config'
import { type TENANT_AND_ENV } from '../../tenant'
import { queryStringEncode } from '../../url-handling'
import { GTM_CONST_API_VERSION_V1 } from '../GTM_CONST'

const getBaseGtmApiUrl = ({
  language,
  tenantAndEnv,
}: {
  language: string
  tenantAndEnv: TENANT_AND_ENV
}): string =>
  `${PUBLIC_API_PREFIX}/api/bully/${language}/gtmDataLayer/${GTM_CONST_API_VERSION_V1}/${tenantAndEnv}`
interface CreateDataUrlParameters {
  language: string
  pageType: PageType
  queryParameters?: Record<string, string[] | string>
  tenantAndEnv: TENANT_AND_ENV
}

/**
 * This urls are where the gtm data shall be fetched from.
 * Clientside a call will be made to this url and response be pushed to dataLayer.
 */
export const gtmBuildGtmApiUrl = ({
  language,
  pageType,
  queryParameters,
  tenantAndEnv,
}: CreateDataUrlParameters): string => {
  let dataUrl = `${getBaseGtmApiUrl({
    language,
    tenantAndEnv,
  })}/events/${pageType}`

  if (!queryParameters) {
    return dataUrl
  }

  dataUrl += `/${queryStringEncode(queryParameters)}`

  return dataUrl
}
